import type { LocalPAPEvent } from "@mirage/service-product-logging/service";

/**
 * Filters out exposure events if hideExposureEvents is true
 */
export const filterExposureEvents = (
  event: LocalPAPEvent,
  hideExposureEvents: boolean,
): boolean => {
  if (hideExposureEvents) {
    return event.action !== "exposure";
  }
  return true;
};

/**
 * Filters out LLM judge relevance events if hideRelevanceEvents is true
 */
export const filterRelevanceEvents = (
  event: LocalPAPEvent,
  hideRelevanceEvents: boolean,
): boolean => {
  if (hideRelevanceEvents) {
    if (
      event.action === "eng" &&
      event.object === "dash_search_result_judge_relevance"
    ) {
      return false;
    }
  }
  return true;
};

/**
 * Filters events based on a text filter with optional negation support
 * Supports negation with "!" prefix
 * Matches against action.object string or any string property values
 */
export const filterByText = (
  event: LocalPAPEvent,
  filterText: string,
): boolean => {
  let searchText = filterText;
  let negate = false;

  if (searchText.startsWith("!")) {
    searchText = searchText.slice(1);
    negate = true;
  }

  const match =
    `${event.action}.${event.object}`.includes(searchText) || searchText === "";

  return negate ? !match : match;
};

/**
 * Combined filter function that applies all filtering logic
 */
export const filterEvents = (
  events: LocalPAPEvent[],
  options: {
    hideExposureEvents?: boolean;
    hideRelevanceEvents?: boolean;
    filterText?: string;
  },
): LocalPAPEvent[] => {
  const {
    hideExposureEvents = false,
    hideRelevanceEvents = false,
    filterText = "",
  } = options;

  return events
    .filter((event) => filterExposureEvents(event, hideExposureEvents))
    .filter((event) => filterRelevanceEvents(event, hideRelevanceEvents))
    .filter((event) => filterByText(event, filterText));
};
